var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "processLogin" } }, [
    _c("section", { staticClass: "section" }, [
      _c("div", { staticClass: "container has-text-centered" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-4 is-offset-4" }, [
            _c("div", { staticClass: "box content" }, [
              _c("img", {
                staticClass: "image",
                attrs: { src: "/statics/signar-logo.svg", alt: "" },
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("p", { staticClass: "is-size-7" }, [
                _vm._v("Procesando inicio de sesión..."),
              ]),
              _vm._v(" "),
              _vm.showPleaseReload
                ? _c("p", { staticClass: "is-size-7 has-text-danger" }, [
                    _vm._v(
                      "\n              ¿No carga? Haga clic\n              "
                    ),
                    _c("a", { attrs: { href: "/" } }, [_vm._v("Aquí")]),
                    _vm._v(" para recargar...\n            "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("p", { staticClass: "is-size-7 mx-2 has-text-grey" }, [
              _vm._v("v" + _vm._s(_vm.version)),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("i", { staticClass: "fas fa-sync fa-spin fa-2x" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { href: "https://lyris.com.ar", target: "_blank" } },
      [
        _c("img", {
          staticClass: "lyris-logo mt-5",
          attrs: { src: "/statics/lyris-grey.svg", alt: "Lyris IT" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "is-size-7 my-3" }, [
      _c(
        "a",
        {
          staticClass: "mx-2 has-text-grey",
          attrs: {
            target: "_blank",
            href: "https://soporte-lyris.atlassian.net/servicedesk/customer/portals",
          },
        },
        [
          _vm._v("Soporte "),
          _c("i", { staticClass: "fas fa-external-link-alt fa-fw" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "mx-2 has-text-grey",
          attrs: { target: "_blank", href: "https://docs.signar.com.ar" },
        },
        [
          _vm._v("Documentación "),
          _c("i", { staticClass: "fas fa-external-link-alt fa-fw" }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }